import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
type ReactLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const ReactLogo: React.FC<ReactLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "React logo";
    t9 = cn("stroke-[#06B6D4]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16512)"><path d="M8.40833 11.6143C4.93899 12.5783 2.66699 14.1823 2.66699 15.9996C2.66699 18.9463 8.63633 21.3329 16.0003 21.3329C17.031 21.3329 18.035 21.2863 18.9977 21.1969" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M23.5893 20.3857C27.06 19.423 29.3333 17.8177 29.3333 16.0003C29.3333 13.0537 23.364 10.667 16 10.667C14.9693 10.667 13.9653 10.7137 13 10.803" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M8.40649 20.3827C7.50515 23.8693 7.75982 26.64 9.33315 27.5467C11.8838 29.02 16.9372 25.044 20.6185 18.6667C21.1345 17.7733 21.5958 16.8813 21.9998 16" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M23.5924 11.6212C24.495 8.13324 24.2417 5.3599 22.667 4.45324C20.1164 2.9799 15.063 6.9559 11.3817 13.3332C10.8657 14.2266 10.4044 15.1199 9.99902 15.9999" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M15.9998 7.23209C13.4332 4.70942 10.9065 3.54409 9.33315 4.45342C6.78248 5.92542 7.69848 12.2894 11.3812 18.6668C11.8958 19.5601 12.4385 20.4054 12.9972 21.1948" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 24.765C18.568 27.289 21.0947 28.4557 22.6667 27.5464C25.2173 26.0744 24.3013 19.7104 20.6187 13.333C20.1187 12.4664 19.5787 11.6224 19.0027 10.8037" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M15.3338 17.1545C15.4855 17.2434 15.6533 17.3015 15.8275 17.3253C16.0017 17.3491 16.1789 17.3382 16.3489 17.2933C16.5189 17.2483 16.6784 17.1702 16.8181 17.0634C16.9577 16.9566 17.0749 16.8232 17.1628 16.6709C17.2508 16.5186 17.3077 16.3505 17.3304 16.1761C17.353 16.0017 17.341 15.8246 17.2949 15.6549C17.2488 15.4852 17.1696 15.3263 17.0619 15.1873C16.9542 15.0483 16.82 14.9321 16.6671 14.8451C16.3611 14.6711 15.9986 14.6252 15.6588 14.7175C15.319 14.8097 15.0295 15.0326 14.8534 15.3376C14.6774 15.6425 14.6291 16.0046 14.7191 16.345C14.8091 16.6854 15.0301 16.9764 15.3338 17.1545Z" stroke="#06B6D4" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16512"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};